
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      variation: this.blok.variation || 'boxed',
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.initAnim()
      }

      // DELETE
      const navigation = document.querySelector('#nav-header-pin')
      const aspot = document.querySelector('#ep-aspot')

      if (!aspot) return

      // change nav bg color when scrolling past Aspot
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: aspot,
          start: '-100% top',
          // end: 'bottom bottom',
          // markers: true,
          onEnter: () => {
            navigation.firstChild.classList.remove('white-bg')
            navigation.firstChild.classList.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeave: () => {
            navigation.firstChild.classList.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation.firstChild.classList.add('white-bg')
          },
          onEnterBack: () => {
            navigation.firstChild.classList.remove('white-bg')
            navigation.firstChild.classList.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeaveBack: () => {
            navigation.firstChild.classList.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation.firstChild.classList.add('white-bg')
          },
        },
      })
    })
  },
  methods: {
    initAnim() {
      if (this.blok.reveal_animation) {
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: this.$el,
              start: 'top bottom-=3%',
              // markers: true,
            },
          })
          .from(this.$refs.header, {
            opacity: 0,
            xPercent: -5,
            duration: 0.5,
            delay: this.blok?.animation_delay,
          })
          .from(
            this.$refs.body,
            {
              autoAlpha: 0,
              // scale: 0.98,
              duration: 0.5,
            },
            '<+=.3'
          )
        this.$ScrollTrigger.refresh(true)
      }
    },
  },
}
